import Vue from 'vue'
import {RecycleScroller} from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
 
Vue.use(RecycleScroller)
Vue.component('virtual-scroller', RecycleScroller)